import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { GemSleepPath } from '../Diagnosis';

function ConsultationConfirmation({ onBookingComplete }) {
    const { bookedAppointment } = useSelector((state) => state.ui.appointmentBooking);
    const { hstInCart } = useSelector((state) => state.cart);

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="layout-outlet-root space-y-4 max-w-2xl">
                <div className="mb-4">
                    <h5 className="mb-4 font-heading text-4xl font-bold lg:text-5xl">Success!</h5>
                    <p className="text-sm lg:text-base">
                        We have you booked for a consultation at the following time:
                    </p>
                    <p className="text-lg py-4">
                        <strong>
                            {format(new Date(bookedAppointment?.startAt), 'EEEE M/d h:mm a')}
                        </strong>
                    </p>
                </div>
                <div className="pt-2">
                    <p className="text-sm">
                        Details of your virtual visit will be emailed to you upon completing
                        checkout.
                    </p>
                    <button className="btn-primary mt-4 w-full" onClick={onBookingComplete}>
                        CONTINUE
                    </button>
                </div>
            </motion.div>
            {hstInCart && (
                <GemSleepPath
                    descriptionText="Once you complete your virtual visit we will ship your Home Sleep Study."
                    pathLabels={[
                        { text: 'Sleep apnea assessment', centered: true },
                        { text: 'Virtual Visit', centered: true },
                        { text: 'Sleep Study', centered: true },
                        { text: 'The right treatment', centered: true },
                        { text: 'Personalized support', centered: true },
                    ]}
                    stepsCompleted={1}
                />
            )}
        </>
    );
}

export default ConsultationConfirmation;
